var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.375C17 15.0981 15.5981 16.5 13.875 16.5H5.75V9.81437L8.22375 6.10375L8.79187 2.125H10.125C10.47 2.125 10.75 2.405 10.75 2.75V7.75H15.75C16.4394 7.75 17 8.31063 17 9V13.375ZM4.5 16.5H2V10.25H4.5V16.5ZM15.75 6.5H12V2.75C12 1.71625 11.1587 0.875 10.125 0.875H8.79187C8.17375 0.875 7.64188 1.33625 7.55438 1.94813L7.02625 5.64625L4.79063 9H0.75V17.75H13.875C16.2875 17.75 18.25 15.7875 18.25 13.375V9C18.25 7.62125 17.1287 6.5 15.75 6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.8caf9448bb1f6aa745b8643fd98d6aee.svg";
export { ForwardRef as ReactComponent };